import { Component, OnInit, Input } from '@angular/core';

import { MediaModel } from '../../models/MediaModel';
import { MediaService } from '../../services/media.service';

@Component({
  selector: 'upload-list-horizontal',
  templateUrl: './upload-list-horizontal.component.html',
  styleUrls: ['./upload-list-horizontal.component.css'],
})
export class UploadListHorizontalComponent implements OnInit {
  @Input() maxHeight: string = '20px';
  @Input() maxWidth: string = '20px';

  private _medias: MediaModel[];
  @Input()
  set medias(value: MediaModel[]) {
    this._medias = value;
  }
  get medias(): MediaModel[] {
    return this._medias;
  }

  constructor(public mediaService: MediaService) {}

  ngOnInit() {}
}
